import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { CommonDatePickerComponent } from "../common-date-picker/common-date-picker.component";
import { ReportArgs } from "../../models/reports.model";

@Component({
    selector: 'report-command',
    templateUrl: './report-command.component.html',
    styleUrls: ['./report-command.component.scss'],
    standalone: false
})
export class ReportCommandComponent implements OnInit {

    @Input() dateRequired: boolean = true;
    @Input() fromDate: Date | null;
    @Input() noDateLabel: string = "";
    @Input() runText: string = "Filter By Date";
    @Input() toDate: Date | null;

    _noDateSelected: boolean = false;
    get noDateSelected(): boolean {
        return this._noDateSelected;
    }

    @Input() set noDateSelected(value: boolean) {
        this._noDateSelected = value;        
    }

    @Output() reportDownloaded: EventEmitter<ReportArgs> = new EventEmitter<ReportArgs>();
    @Output() reportGenerated: EventEmitter<ReportArgs> = new EventEmitter<ReportArgs>();

    get invalidDateCombination(): boolean {
        let invalid: boolean = false;
        if ((this.toDate == null && this.fromDate != null) || (this.fromDate == null && this.toDate != null)) {
            invalid = true;
        } else if (this.toDate == null && this.fromDate == null) {
            invalid = (this.dateRequired) ? true : !this.noDateSelected;
        } else if (this.toDate != null && this.fromDate != null) {
            invalid = this.toDate < this.fromDate;
        }
        return invalid;
    }


    constructor() { }

    ngOnInit() {
    }

    downloadReport(): void {
        let args = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            download: true
        };
        if (this.noDateSelected) {
            args.fromDate = null;
            args.toDate = null;
        }
        this.reportDownloaded.emit(args);
    }

    fromDateChanged(model: Date): void {
        this.fromDate = model;
    }

    toDateChanged(model: Date): void {
        if (model != null) model.setHours(23, 59, 59);
        this.toDate = model;
    }

    generateReport(): void {
        let args = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            download: false
        } as ReportArgs;
        if (this.noDateSelected) {
            args.fromDate = null;
            args.toDate = null;
        }
        
        this.reportGenerated.emit(args);
    }

}


